import { FC, useState } from 'react';
// i18next
import { useTranslation } from 'react-i18next';
// Redux
import { useAppSelector } from 'hooks/useStore';
// Selectors
import { selectQuiz } from 'store/quiz/quizSelectors';
import { selectResult } from 'store/player/playerSelectors';
// Models
import IQuiz from 'models/Quiz';
// Components
import { Button } from 'components/Buttons';
// Hooks
import useNavigateTo from 'hooks/useNavigateTo';
import QuizTypes from 'types/QuizTypes';

const LeaderboardButton:FC = () => {
  const { t } = useTranslation();
  const navigateTo = useNavigateTo();

  const [isHovered, setIsHovered] = useState(false);

  const quiz:IQuiz = useAppSelector(selectQuiz);
  const result:any = useAppSelector(selectResult);

  const isPollQuiz = [QuizTypes.Poll, QuizTypes.RankingPoll].includes(quiz.type);
  const isTeamSelectorQuiz = quiz.type === QuizTypes.TeamSelector;

  const handleClick = () => {
    if (isPollQuiz) {
      navigateTo('results');
    } else if (isTeamSelectorQuiz) {
      navigateTo('teamboard');
    } else {
      navigateTo('leaderboard');
    }
  }

  const label = quiz.callToAction.resultButtonTitle
    ? quiz.callToAction.resultButtonTitle
    : isPollQuiz || isTeamSelectorQuiz
      ? t('buttons.results')
      : t('buttons.leaderboard')

  const isDisabled = quiz.resultsPage.enabled && !isPollQuiz && !result;

  if ( [QuizTypes.Personality, QuizTypes.Survey].includes(quiz.type) ) return null;
  if ( !quiz.resultsPage.enabled ) return null;
  return (
    <div className="z-10 text-center my-4">
      <Button
        className={`
          w-full !text-xl primary-button
          ${isPollQuiz ? 'uppercase' : 'normal-case'}
        `}
        style={{
          transition: 'background 0.3s',
          color: quiz.prizesButtonFontColor,
          background: isHovered
            ? `linear-gradient(to bottom, ${quiz.prizesButtonGradientStart}, ${quiz.prizesButtonGradientEnd})`
            : `linear-gradient(to bottom, ${quiz.prizesButtonGradientEnd}, ${quiz.prizesButtonGradientStart})`
        }}
        size="small"
        onClick={handleClick}
        disabled={isDisabled}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {label}
      </Button>
    </div>
  )
}

export default LeaderboardButton;
